import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgSectionReplyAddresses = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10 9V5L3 12L10 19V14.9C15 14.9 18.5 16.5 21 20C20 15 17 10 10 9Z",
		fill: "#424D57"
	})
});
export default SvgSectionReplyAddresses;
